<template>
<div class="commission-rule-group">
  <div class="title">{{$t('Commission_rebate_rules')}}</div>
  <div class="rule-table-container">
    <div class="rule-table">
    <!-- 表头 -->
    <div class="table-header">
      <div class="header-cell account-type-header">{{$t('Home.accountType')}}</div>
      <div 
        class="header-cell" 
        v-for="(headerItem, k) in SelfRuleData[0] ? SelfRuleData[0].symbolGroup : []" 
        :key="k"
      >
        {{headerItem.name}}
      </div>
    </div>
    <!-- 表格内容 -->
    <div 
      class="table-row" 
      v-for="(item, index) in SelfRuleData" 
      :key="index"
    >
      <div class="row-cell account-type-cell">{{item.mt4GroupNamme}}</div>
      <div 
        class="row-cell" 
        v-for="(itemInner, i) in item.symbolGroup" 
        :key="i"
        :data-label="itemInner.name"
      >
        <span v-if="isReadonly || itemInner.max == -1">
           {{getReadonlyText(itemInner)}}
           <span>{{getSuffix(itemInner.suffix,itemInner)}}</span>
        </span>
        <div v-else class="input-box">
          <el-input
            maxLength="6"
            :disabled="isDisabeld"
            :placeholder="getPlaceholder(itemInner.max,index,i)"
            v-model="itemInner.value"
            @blur="blurHandle(itemInner, index, i)"
            :class="validateClass(itemInner,index,i)"
          >
            <span slot="suffix" class="suffix-self">{{getSuffix(itemInner.suffix,itemInner)}}</span>
          </el-input>
          <div v-if="itemInner.validateError" class="error-message">{{getErrorMessage(itemInner,index)}}</div>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { getRuleValidateFlag,getHandleRuleData } from "@/utils/common";

export default {
  name: "commissionRuleGroup",
  props: {
    ruleData: {
      type: Array,
      default(){
        return [];
      }
    },
    fatherRuleData:{
      type: Array,
      default(){
        return []
      }
    },
    isDisabeld:{
      type: Boolean,
      default: false,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      SelfRuleData: JSON.parse(JSON.stringify(this.ruleData)),
    }
  },
  watch:{
    ruleData(newVal){
      this.SelfRuleData = JSON.parse(JSON.stringify(newVal.slice(0)));
    },
  },
  methods: {
    // 重置所有验证状态
    resetValidateStatus(){
      if(!this.SelfRuleData || !this.SelfRuleData.length){
        return;
      }
      for (let i = 0; i < this.SelfRuleData.length; i++) {
        for (let j = 0; j < this.SelfRuleData[i].symbolGroup.length; j++) {
          this.SelfRuleData[i].symbolGroup[j].validateError = false;
          this.SelfRuleData[i].symbolGroup[j].validateErrorType = '';
          this.SelfRuleData[i].symbolGroup[j].maxValue = null;
          this.SelfRuleData[i].symbolGroup[j].value = '';
        }
      }
      // 强制重新渲染
      this.$forceUpdate();
    },
    clearCom(dataList){
      if(!dataList.length){
          return;
      }
      for (let i = 0; i < dataList.length; i++) {
        for (let j = 0; j < dataList[i].symbolGroup.length; j++) {
          dataList[i].symbolGroup[j].value = '';
        }
      }
    },
    getSuffix(suffix,colItem){
      if(colItem.max == -1){
        return '';
      }
      if(suffix === 1){
        return '$' + '/lot';
      }else if(suffix === 3){
        return 'pips' + '/lot'
      }if(suffix === 4){
        return '%';
      }
    },
    getReadonlyText(item){
      if(item.max == -1){
        return '/'
      }
      return `${item.value}`;
    },
    getPlaceholder(max,index,i){
      if(max == -1){
        return '/';
      }
      if(this.fatherRuleData.length){
        return this.fatherRuleData[index].symbolGroup[i].value;
      }else {
        return '≤' + max;
      }
    },
    blurHandle(colItem,index,i){
      console.log(colItem);
      // 重置当前输入项的错误状态
      colItem.validateError = false;
      colItem.validateErrorType = '';
      colItem.maxValue = null;
      
      // 非空验证
      if(colItem.value === ''){
        colItem.validateError = true;
        colItem.validateErrorType = 'empty';
      } else {
        // 负数验证
        if(parseFloat(colItem.value) < 0){
          colItem.validateError = true;
          colItem.validateErrorType = 'negative';
        } else {
          // 格式验证
          const centItem = this.SelfRuleData.find(item => item.symbolGroup.includes(colItem));
          const isCent = centItem ? centItem.mt4GroupNamme === 'Cent' : false;
          const isStockCrypto = colItem.name === 'Stock' || colItem.name === 'Crypto';
          
          let valid = true;
          if (isCent) {
            if (isStockCrypto) {
              // Cent 且是 Stock 或 Crypto：最多两位小数
              valid = /^[0-9]+(\.[0-9]{1,2})?$/.test(colItem.value);
            } else {
              // Cent 且不是 Stock 或 Crypto：最多四位小数
              valid = /^[0-9]+(\.[0-9]{1,4})?$/.test(colItem.value);
            }
          } else {
            if (isStockCrypto) {
              // 非 Cent 且是 Stock 或 Crypto：只能是整数
              valid = /^[0-9]+$/.test(colItem.value);
            } else {
              // 非 Cent 且不是 Stock 或 Crypto：最多一位小数
              valid = /^[0-9]+(\.[0-9]{1})?$/.test(colItem.value);
            }
          }
          
          if(!valid){
            colItem.validateError = true;
            colItem.validateErrorType = 'format';
          } else {
            // 佣金规则验证
            if(!this.fatherRuleData.length){
              if(colItem.value > colItem.max){
                colItem.validateError = true;
                colItem.validateErrorType = 'commission';
                colItem.maxValue = colItem.max;
              }
            }else {
              // 编辑佣金规则
              if(parseFloat(colItem.value) > this.fatherRuleData[index].symbolGroup[i].value){
                colItem.validateError = true;
                colItem.validateErrorType = 'commission';
                colItem.maxValue = this.fatherRuleData[index].symbolGroup[i].value;
              }
            }
          }
        }
      }
      
      // 强制重新渲染以显示错误提示
      this.$forceUpdate();
    },
    validateClass(colItem,index,i){
      if(colItem.validateError){
        return 'nopass';
      }
      if(!this.fatherRuleData.length){
        if(colItem.value > colItem.max){
          return 'nopass';
        }else {
          return '';
        }
      }else {
        if(colItem.value > this.fatherRuleData[index].symbolGroup[i].value){
          return 'nopass';
        }else {
          return '';
        }
      }
    },
    getErrorMessage(colItem,index){    
      if(colItem.validateErrorType === 'empty'){
        return this.$t('cannot_be_empty');
      } else if(colItem.validateErrorType === 'commission'){
        return this.$t('The_highest_can_be_set') + ' '+ colItem.maxValue;
      } else if(colItem.validateErrorType === 'negative'){
        return this.$t('cannot_be_negative');
      } else {
        const isCent = this.SelfRuleData[index].mt4GroupNamme === 'Cent';
        const isStockCrypto = colItem.name === 'Stock' || colItem.name === 'Crypto';
        
        if (isCent) {
          if (isStockCrypto) {
            return this.$t('max_two_decimal_places');
          } else {
            return this.$t('max_four_decimal_places');
          }
        } else {
          if (isStockCrypto) {
            return this.$t('only_integers_allowed');
          } else {
            return this.$t('max_one_decimal_place');
          }
        }
      }
    },
    validateTable(){
      let pass = getRuleValidateFlag(this.SelfRuleData,this.fatherRuleData,this);
      console.log('validateTable called, pass:', pass);
      console.log('SelfRuleData after validation:', this.SelfRuleData);
      
      this.$forceUpdate();
      
      if(!pass){
        return;
      }else {
        let copySelfRuleData = getHandleRuleData(this.SelfRuleData);
        this.$emit('submit',copySelfRuleData);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.commission-rule-group {
  .title {
    margin-bottom: 10px;
  }
  .rule-table-container {
    overflow-x: auto;
    margin: 0 -10px;
    padding: 0 10px;
    
    // 手机端自动撑开高度，不显示滚动条
    @media (max-width: 768px) {
      overflow-y: visible;
      max-height: none;
    }
  }
  .rule-table {
        border: 1px solid #EBE9F1;
        border-radius: 5px;
        overflow: hidden;
        display: table;
        width: 100%;
        min-width: 768px;
    
    // 手机端：改为块级布局
    @media (max-width: 768px) {
      display: block;
      min-width: auto;
    }
    
    .table-header {
      display: table-row;
      background-color: #F3F2F7;
      font-weight: bold;
      color: #5E5873;
      
      // 手机端隐藏表头
      @media (max-width: 768px) {
        display: none;
      }
      
      .header-cell {
        display: table-cell;
        padding: 12px 8px;
        text-align: center;
        border-right: 1px solid #EBE9F1;
        border-bottom: 1px solid #EBE9F1;
        font-size: 13px;
        vertical-align: middle;
        min-width: 130px;
        @media (max-width: 768px) {
          min-width: 130px;
        }
        
        &:last-child {
          border-right: none;
        }
        
        &.account-type-header {
          width: 120px;
          min-width: 120px;
        }
      }
    }
    
    .table-row {
      display: table-row;
      
      // 手机端：从上往下排列
      @media (max-width: 768px) {
        display: block !important; // 强制使用 block 布局
        border-bottom: 1px solid #EBE9F1;
        padding: 10px 0;
        
        &:last-child {
          border-bottom: none;
        }
        
        // 账户类型单元格单独占一行
        .row-cell.account-type-cell {
          display: block !important;
          width: 100% !important; // 强制撑满整行
          background-color: #F3F2F7;
          font-weight: bold;
          padding: 12px 10px;
          text-align: center;
          justify-content: center;
          border-bottom: 2px solid #EBE9F1;
          margin-bottom: 5px;
          
          &::before {
            content: '' !important; // 移除标签
          }
        }
        
        .row-cell {
          display: flex !important; // 强制使用 flex 布局
          justify-content: space-between;
          align-items: center;
          padding: 8px 10px;
          border: none;
          border-bottom: 1px solid #f0f0f0;
          min-width: auto;
          width: 100%;
          box-sizing: border-box;
          
          &:last-child {
            border-bottom: none;
          }
          
          // 在左侧添加标签
          &::before {
            content: attr(data-label);
            font-weight: 500;
            color: #5E5873;
            margin-right: 10px;
            white-space: nowrap;
            flex-shrink: 0;
          }
          
          .input-box {
            flex: 1;
            min-width: auto;
            width: 100%;
            max-width: 200px;
          }
        }
      }
      
      &:last-child {
        .row-cell {
          border-bottom: none;
        }
      }
      
      .row-cell {
        display: table-cell;
        padding: 10px 8px;
        text-align: center;
        border-right: 1px solid #EBE9F1;
        border-bottom: 1px solid #EBE9F1;
        vertical-align: middle;
        min-width: 120px;
        @media (max-width: 768px) {
          min-width: 100px;
        }
        
        &:last-child {
          border-right: none;
        }
        
        &.account-type-cell {
          width: 120px;
          min-width: 120px;
          font-weight: 500;
          background-color: #FAFAFA;
          
          // 手机端：去掉宽度限制，撑满整行
          @media (max-width: 768px) {
            width: auto;
            min-width: auto;
          }
        }
        
        .input-box {
          width: 100%;
          min-width: 80px;
          position: relative;
          @media (max-width: 768px) {
            min-width: 70px;
          }
          
          .suffix-self {
            font-size: 12px;
            color: #606266;
            display: flex;
            align-items: center;
            height: 100%;
            @media (max-width: 768px) {
              font-size: 11px;
            }
          }
          
          .error-message {
            font-size: 11px;
            text-align: left;
            color: red;
            margin-top: 4px;
            line-height: 1.3;
            white-space: normal;
            word-break: break-all;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.commission-rule-group {
  .nopass {
    .el-input__inner {
      color: red;
      border: 1px solid red;
    }
  }
  .el-input__inner {
    padding-right: 50px;
    min-width: 80px;
    @media (max-width: 768px) {
      padding-right: 40px;
      font-size: 12px;
      min-width: 70px;
    }
  }
}
</style>
